import { Spinner as SpinnerIcon } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import { SkeletonCard, SkeletonRow, LoadingCard, Spinner } from "../loading";

export function LoadingSection() {
  return (
    <SectionShell
      id="loading"
      eyebrow="Loading"
      eyebrowIcon={SpinnerIcon}
      title="Calm waiting, never anxious"
      description="Loading should feel like a gentle breath. Soft skeletons keep the layout steady, and a friendly mascot reassures children that something good is on its way."
    >
      <div className="space-y-5">
        <Showcase title="Skeleton cards" tone="muted">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        </Showcase>

        <Showcase title="Skeleton rows" tone="muted">
          <div className="space-y-3">
            <SkeletonRow />
            <SkeletonRow />
          </div>
        </Showcase>

        <div className="grid gap-5 lg:grid-cols-2">
          <Showcase title="Loading card"><LoadingCard /></Showcase>
          <Showcase title="Inline spinners">
            <div className="flex items-center gap-6">
              <Spinner size={20} />
              <Spinner size={28} />
              <Spinner size={40} />
              <span className="font-semibold text-muted-foreground">Soft, slow, never frantic.</span>
            </div>
          </Showcase>
        </div>
      </div>
    </SectionShell>
  );
}

export default LoadingSection;
